import * as React from 'react';
import {
  TopLayer,
  BottomLayer,
  content,
  SpanContent,
  textAlignment,
  getLinkClass,
  // eslint-disable-next-line
  ButtonProps,
} from './OffSetButton.css';

interface OffSetButtonProps extends ButtonProps {
  onClick?: () => void;
  hrefLink?: string;
  fontColor?: string;
  bottomColor?: string;
  uncentered?: boolean;
}

function getColor(fontColor?: string, textColor?: string): string {
  if (fontColor) return fontColor;
  if (textColor) return textColor;
  return 'white';
}

function getColorObj(
  fontColor?: string,
  textColor?: string,
): { color: string } {
  return { color: getColor(fontColor, textColor) };
}

const noop = () => {};

const OffSetButton = ({
  onClick,
  text,
  color,
  bottomColor,
  fontColor,
  textColor,
  disabled,
  hrefLink,
  uncentered,
}: OffSetButtonProps) => (
  <SpanContent centered={!uncentered}>
    <a
      className={getLinkClass(disabled)}
      data-cypress={`offsetButton-${text}`}
      href={hrefLink}
      onClick={disabled ? noop : onClick}
      onKeyPress={disabled ? noop : onClick}
    >
      <BottomLayer color={color} bottomColor={bottomColor}>
        <TopLayer color={color}>
          <span
            className={textAlignment}
            style={getColorObj(fontColor, textColor)}
          >
            {text}
          </span>
        </TopLayer>
      </BottomLayer>
    </a>
  </SpanContent>
);

export default OffSetButton;
